import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
//import { Link } from 'react-router-dom';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { selectUser } from 'src/app/auth/user/store/userSlice';
// import useAuth from 'src/app/auth/useAuth';
import { darken } from '@mui/material/styles';
import { useAppSelector } from 'app/store/hooks';
import { useAuthInfo } from "@propelauth/react";
import { useTranslation } from 'react-i18next';


import { useRedirectFunctions, useLogoutFunction } from '@propelauth/react';
import { useRoleBasedRedirect } from 'src/app/auth/useRoleBasedRedirect';
// import { setUser } from 'src/app/auth/user/store/userSlice';


/**
 * The user menu.
 */
function UserMenu() {
    const { t } = useTranslation();

    //get user from redux and update it 
    const user = useAppSelector(selectUser);
    // const { signOut } = useAuth();

    const { redirectToLoginPage, redirectToAccountPage, redirectToSignupPage } = useRedirectFunctions();
    const { getRoleBasedRedirectUrl } = useRoleBasedRedirect();

    const logoutFunction = useLogoutFunction();

    const handleLogOut = () => {
        logoutFunction(true)
            .then(() => {
                window.location.href = '/sign-in';
            })
            .catch((error) => {
                console.error("Logout failed:", error);
            });
    }



    const [userMenu, setUserMenu] = useState<HTMLElement | null>(null);

    const userMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setUserMenu(event.currentTarget);
    };

    const userMenuClose = () => {
        setUserMenu(null);
    };



    if (!user) {
        return null;
    }






    return (
        <>
            <Button
                className="min-h-40 min-w-40 p-0 md:px-16 md:py-6"
                onClick={userMenuClick}
                color="inherit"
            >
                <div className="mx-4 hidden flex-col items-end md:flex">
                    <Typography
                        component="span"
                        className="flex font-semibold"
                    >
                        {user.first_name} {user.last_name}
                    </Typography>
                    <Typography
                        className="text-11 font-medium capitalize"
                        color="text.secondary"
                    >
                        {user.role?.toString()}
                        {(!user.role || (Array.isArray(user.role) && user.role.length === 0)) && 'Guest'}

                    </Typography>
                </div>

                {user.data.photoURL ? (
                    <Avatar
                        sx={{
                            background: (theme) => theme.palette.background.default,
                            color: (theme) => theme.palette.text.secondary
                        }}
                        className="md:mx-4"
                        alt="user photo"
                        src={user.data.photoURL}
                    />
                ) : (
                    <Avatar
                        sx={{
                            background: (theme) => darken(theme.palette.background.default, 0.05),
                            color: (theme) => theme.palette.text.secondary
                        }}
                        className="md:mx-4"
                    >
                        {user?.first_name?.[0]}
                    </Avatar>
                )}
            </Button>

            <Popover
                open={Boolean(userMenu)}
                anchorEl={userMenu}
                onClose={userMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                classes={{
                    paper: 'py-8'
                }}
            >
                {!user.role || user.role.length === 0 ? (
                    <>
                        <MenuItem
                            onClick={() => {
                                const redirectUrl = getRoleBasedRedirectUrl();
                                redirectToLoginPage({
                                    postLoginRedirectUrl: redirectUrl
                                });
                            }}
                        >
                            <ListItemIcon className="min-w-40">
                                <FuseSvgIcon>heroicons-outline:lock-closed</FuseSvgIcon>
                            </ListItemIcon>
                            <ListItemText primary="Sign In" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => redirectToSignupPage()}
                        >
                            <ListItemIcon className="min-w-40">
                                <FuseSvgIcon>heroicons-outline:user-add </FuseSvgIcon>
                            </ListItemIcon>
                            <ListItemText primary="Sign up" />
                        </MenuItem>
                    </>
                ) : (
                    <>
                        <MenuItem
                            onClick={() => redirectToAccountPage()}
                        >
                            <ListItemIcon className="min-w-40">
                                <FuseSvgIcon>heroicons-outline:user-circle</FuseSvgIcon>
                            </ListItemIcon>
                            <ListItemText primary={t('ACCOUNT')} />
                        </MenuItem>
                        <MenuItem
                            onClick={handleLogOut}
                        >
                            <ListItemIcon className="min-w-40">
                                <FuseSvgIcon>material-outline:logout</FuseSvgIcon>
                            </ListItemIcon>
                            <ListItemText primary={t('LOG_OUT')} />
                        </MenuItem>
                    </>
                )}
            </Popover>
        </>
    );
}

export default UserMenu;
